<template>
  <div class="app-container">
    <el-form class="demo-ruleForm" label-position="top" size="medium">
      <el-form-item
        label="僵尸车判定时间设置（天）"
        style="margin-bottom: 50px"
      >
        <el-input-number
          style="min-width: 202px"
          :precision="0"
          v-model="day_times"
          :min="0"
          :max="300"
          label="僵尸车判定时间设置"
        ></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button
          type="success"
          @click="editForm"
          v-if="roles.includes('/conf/set_zombie_vehicle_time')"
        >
          修改
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { get_zombie_vehicle_time, set_zombie_vehicle_time } from "@/api/conf";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  data() {
    return {
      day_times: "",
    };
  },
  created() {
    this.getinfo();
  },
  mounted() {},
  methods: {
    getinfo() {
      get_zombie_vehicle_time().then((res) => {
        if (res.data instanceof Array) {
          this.day_times = 90;
        } else {
          this.day_times = res.data.day_times;
        }
      });
    },
    editForm() {
      if (this.day_times > 0) {
        set_zombie_vehicle_time({ day_times: this.day_times }).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
          });
        });
      } else {
        this.$message({
          message: "时间不能小于1天",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  padding: 30px;
}
</style>
